var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProcessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.41667 17.3333C1.80584 17.3333 0.5 16.0274 0.5 14.4166C0.5 13.0203 1.48117 11.8532 2.79167 11.567V8.9999C2.79167 8.6547 3.07149 8.3749 3.41667 8.3749H7.375V6.4328C6.06451 6.1467 5.08333 4.9796 5.08333 3.5833C5.08333 1.9724 6.38917 0.666601 8 0.666601C9.6108 0.666601 10.9167 1.9724 10.9167 3.5833C10.9167 4.9796 9.9355 6.1467 8.625 6.4328V8.3749H12.5833C12.9285 8.3749 13.2083 8.6547 13.2083 8.9999V11.567C14.5188 11.8532 15.5 13.0203 15.5 14.4166C15.5 16.0274 14.1942 17.3333 12.5833 17.3333C10.9725 17.3333 9.6667 16.0274 9.6667 14.4166C9.6667 13.0203 10.6478 11.8532 11.9583 11.567V9.62492H4.04167V11.567C5.35216 11.8532 6.33333 13.0203 6.33333 14.4166C6.33333 16.0274 5.0275 17.3333 3.41667 17.3333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessIcon);
export default __webpack_public_path__ + "static/media/process-icon.d91a3eacf9c185414f5a4123feb13738.svg";
export { ForwardRef as ReactComponent };